module.exports = __webpack_public_path__ + "img/hr-assembling-machine-3-pipe-E.013fb441.png";